import { isAfter } from 'date-fns'
import useModalOpenState from 'marketing-site/lib/useModalOpenState'
import { useEffect } from 'react'
import { ExitIntentModalService, useGetShowModalDelayTime } from './ExitIntentModalService'

const { getStateManager } = ExitIntentModalService

/**
 *
 * @param id
 * @param modalConfiguration
 * @returns
 *
 * Trigger intent modal when user exits cursor out of the main content and when other conditions are met
 * see `getShouldOpenModal` for more details
 */
export const useExitIntentModalTrigger = (id: string, modalConfiguration?: Record<string, any>) => {
  const [isModalOpen, openModal, closeModal] = useModalOpenState()

  const activateModalAfterMs = useGetShowModalDelayTime(modalConfiguration)

  const stateManager = getStateManager(id)
  const isDismissed = stateManager.getWasModalDismissed()

  const shouldShowModal = stateManager.getShouldOpenModal()

  useEffect(() => {
    if (isModalOpen || isDismissed) return

    function onMouseOut(event: MouseEvent) {
      const isAfterDelay = isAfter(new Date(), activateModalAfterMs.current)
      const userIntendsToExit = event.clientY <= 0

      if (shouldShowModal && isAfterDelay && userIntendsToExit) {
        stateManager.incrementNumberOfModalViews()
        openModal()
      }
    }

    window.addEventListener('mouseout', onMouseOut)
    return () => window.removeEventListener('mouseout', onMouseOut)
  }, [isModalOpen, openModal, shouldShowModal, isDismissed])

  return {
    isModalOpen,
    closeModal,
  }
}
